import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { ApiContext, NavigationContext, UserContext } from "../contexts";
import { IconName,RoutePath } from "../types";
import Icon from "./Icon";

const KioskModeRestartFooter = observer(() => {
  const apiContext = useContext(ApiContext);
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);

  const onClickLogout = async () => {
    const result = confirm(
      "Are you sure you want to restart? All current selections will be lost."
    );
    if (result) {
      await apiContext.logoutUser();

      navContext.goTo(RoutePath.HOME);
      userContext.reset();
      apiContext.reset();

      userContext.setFirstName("");
      userContext.setLastName("");
      userContext.setPhone("");
      userContext.setEmail("");
      userContext.setConsultant(null);
      userContext.setIsLoggedIn(false);
    }
  };

  const onClickRestart = () => {
    const result = confirm(
      "Are you sure you want to stay logged in and restart? All current selections will be lost."
    );
    if (result) {
      navContext.goTo(RoutePath.HOME);
      userContext.reset();
      apiContext.reset();
    }
  };

  const onClickNextBtn = () => {
    navContext.goNext();
  };

  if (!navContext.footerNavVisible) {
    return <></>;
  }

  return (
    <div className={"footer-nav kiosk-mode-restart-footer"}>
      <div className={"container"}>
        <div className={"restart-btn-container"}>
          <button className={"btn restart-btn"} onClick={onClickLogout}>
            <Icon name={IconName.RESTART} />
            <span>Start New Session</span>
          </button>
        </div>
        <div className={"footer-center"} />
        {!navContext.nextBtnVisible ? (
          <div className={"restart-btn-container"}>
            <button className={"btn restart-btn"} onClick={onClickRestart}>
              <Icon name={IconName.RESTART} />
              <span>Design & Price Again</span>
            </button>
          </div>
        ) : (
          <div className={"next-btn-container"}>
            <button
              className={"btn next-btn"}
              onClick={onClickNextBtn}
              disabled={!navContext.nextBtnEnabled}
            >
              {!navContext.nextBtnText ? (
                <>
                  <Icon name={IconName.ARROW} />
                  <span>{"Next"}</span>
                </>
              ) : (
                navContext.nextBtnText
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

export default KioskModeRestartFooter;
